// Styles
import styles from './cardValues.module.css';

export const BooleanValue = ({ value }: { value: boolean }) => {
  return <span>{value ? 'Yes' : 'No'}</span>;
};

export const StringValue = ({ value }: { value: string }) => {
  return <span>{value}</span>;
};

export const ArrayValue = ({ value }: { value: any[] }) => {
  if (!value || value.length === 0) return null;

  return (
    <>
      {value.map((item, index) => (
        <div key={index}
          className={`${index !== value.length - 1 ? styles.borderBottom : ''}`}>
          {typeof item === 'string' ? (
            <StringValue value={item} />
          ) : typeof item === 'object' ? (
            <ObjectValue value={item} />
          ) : typeof item === 'boolean' ? (
            <BooleanValue value={item} />
          ) : null}
        </div>
      ))}
    </>
  );
};

export const splitCamelCase = (str: string) => {
  if (!str) return str;
  const result = str.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return result.replace(/\b\w/g, char => char.toUpperCase());
};

export const ObjectValue = ({ value }: { value: Record<string, any> }) => {
  if (!value || typeof value !== 'object') {
    return null;
  }

  return (
    <>
      {Object.entries(value).map(([key, val], index) => {
        if (Array.isArray(val) && val.length === 0) return null;

        return (
          <div className={styles.treeWrapper} key={index}>
            <span className={styles.treeKey}>- {splitCamelCase(key)}:</span>
            <span className={styles.treeValue}>
              {typeof val === 'string' ? (
                <StringValue value={val} />
              ) : typeof val === 'boolean' ? (
                <BooleanValue value={val} />
              ) : typeof val === 'object' ? (
                Array.isArray(val) ? (
                  <ArrayValue value={val} />
                ) : (
                  <ObjectValue value={val} />
                )
              ) : (
                String(val)
              )}
            </span>
          </div>
        );
      })}
    </>
  );
};